export const PROFILES = "/v1/profile/";
export const CREATE_PROFILE = "/v1/profile/";
export const UPDATE_PROFILE = "/v1/profile/";